{
    "Accessibility Menu": "Menu Aksesibilitas",
    "Reset settings": "Atur Ulang Pengaturan",
    "Close": "Tutup",
    "Content Adjustments": "Penyesuaian Konten",
    "Adjust Font Size": "Sesuaikan Ukuran Font",
    "Highlight Title": "Sorot Judul",
    "Highlight Links": "Sorot Tautan",
    "Readable Font": "Font Mudah Dibaca",
    "Color Adjustments": "Penyesuaian Warna",
    "Dark Contrast": "Kontras Gelap",
    "Light Contrast": "Kontras Terang",
    "High Contrast": "Kontras Tinggi",
    "High Saturation": "Saturasi Tinggi",
    "Low Saturation": "Saturasi Rendah",
    "Monochrome": "Monokrom",
    "Tools": "Alat",
    "Reading Guide": "Panduan Membaca",
    "Stop Animations": "Hentikan Animasi",
    "Big Cursor": "Kursor Besar",
    "Increase Font Size": "Perbesar Ukuran Font",
    "Decrease Font Size": "Perkecil Ukuran Font",
    "Letter Spacing": "Jarak Huruf",
    "Line Height": "Tinggi Baris",
    "Font Weight": "Ketebalan Font",
    "Dyslexia Font": "Font Disleksia",
    "Language": "Bahasa",
    "Open Accessibility Menu": "Buka menu aksesibilitas"
}
  